import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import UserModal from './user-modal';
import { PATH } from '../../../constants';

function createContainer() {
  const element = document.createElement('div');
  element.setAttribute('id', 'user-modal');
  document.getElementsByTagName('body')[0].appendChild(element);
  return element;
}

function hideUserModal(container) {
  const node = container || global.document.getElementById('user-modal');
  unmountComponentAtNode(node);
}

function showUserModal(
  callback,
  publicIntegrations,
  integrations,
  onEventFired,
  datalayerFields,
  currentScreenProp
) {
  const urlParams = new URLSearchParams(window.location.search);
  const source =
    global.location.pathname === PATH.HOME
      ? 'home'
      : global.location.pathname + global.location.search;
  const currentScreen =
    urlParams.has('bq_action') && urlParams.get('bq_action') === 'signup' ? 'SignUp' : 'Login';

  global.location =
    currentScreen === 'SignUp'
      ? PATH.SIGN_UP + `?source=${source}`
      : PATH.LOGIN + `?source=${source}`;

  if (currentScreen === 'SignUp' || currentScreen === 'Login') return;

  const container = global.document.getElementById('user-modal') || createContainer();
  const onComplete = (member, socialMedia) => {
    if (member) {
      callback('loginSuccess', socialMedia, member); // eslint-disable-line standard/no-callback-literal
    }
    hideUserModal(container);
  };

  render(
    <UserModal
      onComplete={onComplete}
      onEventFired={onEventFired}
      publicIntegrations={publicIntegrations}
      integrations={integrations}
      datalayerFields={datalayerFields}
      currentScreen={currentScreenProp || currentScreen}
    />,
    container
  );
}

export default {
  open: showUserModal,
  close: hideUserModal
};
